<template>
  <DsButton
    full
    hierarchy="secondary"
    :loading="loading"
    @click="loading ? undefined : $emit('click')"
  >
    <slot />
  </DsButton>
</template>

<script setup lang="ts">
defineEmits<{
  (e: 'click'): void;
}>();

defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.ds-button :deep(span) {
  @apply tw-font-montserrat-semibold tw-text-cool-grey-500 tw-text-base;
}
.ds-button.--color-secondary {
  @apply tw-border-secondary-light;
}

.ds-button {
  @apply tw-py-[10px];
}
</style>
